import { render, staticRenderFns } from "./AdminBidRequestDetails.vue?vue&type=template&id=6aae9254&scoped=true"
import script from "./AdminBidRequestDetails.vue?vue&type=script&lang=js"
export * from "./AdminBidRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminBidRequestDetails.vue?vue&type=style&index=0&id=6aae9254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae9254",
  null
  
)

export default component.exports